import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class ListFollowUpsService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  params = new HttpParams();

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  listFollowUps(userId, givenToUserId) {
    let sectionId = this.common.getSelectedSection().sectionId;

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    this.params = this.params.set('givenTo', givenToUserId);

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/followUps`, { params: this.params, headers: this.headers });
  }
}
